const Global = {};

export default Global;
